// ==================== TodayLeaves.jsx ====================
import React, { useEffect, useState } from "react";
import "../Styling/TodayLeaves.css";
import { Base_URL } from "../url";
import { useAuth } from "../Context/AuthContext";
import { UsersRound } from "lucide-react";

const TodayLeaves = ({ filters }) => {
  const { user } = useAuth();

  // ✅ prefer filters, fallback to logged-in user
  const orgId = filters?.orgId || user?.organisationId;
  const companyCode = filters?.companyCode || user?.companyCode || "";
  const fiscalYear = filters?.fiscalYear || "All Fiscal Years";

  const [leaves, setLeaves] = useState([]);
  const [departments, setDepartments] = useState([]);

  const [typeFilter, setTypeFilter] = useState("All");
  const [deptFilter, setDeptFilter] = useState("All");

  const today = new Date().toISOString().split("T")[0];

  useEffect(() => {
    if (!orgId) return;

    const fetchTodayData = async () => {
      try {
        /* ================= Today's Leaves ================= */
        const leaveParams = new URLSearchParams({
          today,
        });

        if (companyCode) leaveParams.append("companyCode", companyCode);
        if (fiscalYear && fiscalYear !== "All Fiscal Years") {
          leaveParams.append("fiscalYear", fiscalYear);
        }

        const leaveRes = await fetch(
          `${Base_URL}/Leave/GetLeavesForToday/${orgId}?${leaveParams.toString()}`
        );
        const leaveData = await leaveRes.json();
        setLeaves(Array.isArray(leaveData) ? leaveData : []);

        /* ================= Departments ================= */
        const deptParams = new URLSearchParams();
        if (companyCode) deptParams.append("companyCode", companyCode);

        const deptRes = await fetch(
          `${Base_URL}/DepartmentList/GetAllDepartments?${deptParams.toString()}`
        );
        const deptData = await deptRes.json();
        setDepartments(Array.isArray(deptData) ? deptData : []);
      } catch (err) {
        console.error("❌ Today leaves error:", err);
        setLeaves([]);
        setDepartments([]);
      }
    };

    fetchTodayData();
  }, [orgId, companyCode, fiscalYear, today]); // 🔥 filter-driven

  const filtered = leaves.filter(l => {
    const typeMatch =
      typeFilter === "All" ||
      l.leaves?.toLowerCase().includes(typeFilter.toLowerCase());

    const deptMatch =
      deptFilter === "All" || l.department === deptFilter;

    return typeMatch && deptMatch;
  });

return (
  <div className="tdl-card">
    <div className="tdl-header">

      <div className="tdl-header-left">
        <div className="tdl-icon">
          <UsersRound size={18} />
        </div>
        <h6 className="tdl-title">Today Status</h6>
      </div>

      <div className="tdl-filters">
        <select
          className="tdl-select"
          value={typeFilter}
          onChange={(e) => setTypeFilter(e.target.value)}
        >
          <option value="All">All</option>
          <option value="Leave">Leave</option>
          <option value="WFH">WFH</option>
        </select>

        <select
          className="tdl-select"
          value={deptFilter}
          onChange={(e) => setDeptFilter(e.target.value)}
        >
          <option value="All">All Depts</option>
          {departments.map((d, i) => (
            <option key={i} value={d.deptDescription}>
              {d.deptDescription}
            </option>
          ))}
        </select>
      </div>
    </div>

    <div className="tdl-list">
      {filtered.length === 0 ? (
        <div className="tdl-empty">No employees today</div>
      ) : (
        filtered.map((item, idx) => (
          <div className="tdl-row" key={idx}>

            <div className="tdl-left">
              <div className="tdl-avatar">
                {item.resource?.charAt(0)}
              </div>

              <div className="tdl-info">
                <div className="tdl-name">{item.resource}</div>
                <div className="tdl-dept">{item.department}</div>
              </div>
            </div>

<span
  className={`tdl-status 
    ${item.leaves === "WFH" ? "tdl-wfh" : "tdl-leave"} 
    ${item.status === "Pending" ? "tdl-pending" : "tdl-confirmed"}
  `}
>
  {item.leaves} • {item.status}
</span>
          </div>
        ))
      )}
    </div>
  </div>
);
};

export default TodayLeaves;
